import { DateField } from 'admin';
import type { Load } from 'api';
import type { DataGridColumn } from 'ui';

import { RISK_SCORE_OPTIONS, RiskScoreChip } from '~/risk';

import { LoadStatusChip } from '../../components/LoadStatusChip/LoadStatusChip';
import { LOADS_STATUS_OPTIONS } from './constants';

export const columns: DataGridColumn<Load>[] = [
  {
    columnSize: 'small',
    field: 'deal_id',
    filterable: true,
    headerName: 'Deal',
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'small',
    field: 'id',
    filterable: true,
    headerName: 'Load',
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'large',
    field: 'material',
    filterable: true,
    headerName: 'Material',
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'medium',
    field: 'status',
    filterable: true,
    headerName: 'Status',
    renderCell: (params) => {
      return <LoadStatusChip status={params.value} />;
    },
    sortable: true,
    type: 'singleSelect',
    valueOptions: LOADS_STATUS_OPTIONS,
  },
  {
    columnSize: 'medium',
    field: 'risk_score',
    filterable: true,
    headerName: 'Risk',
    renderCell: (params) => {
      return <RiskScoreChip riskScore={params.value} />;
    },
    sortable: true,
    type: 'singleSelect',
    valueOptions: RISK_SCORE_OPTIONS,
  },
  {
    columnSize: 'large',
    field: 'producer',
    filterable: true,
    headerName: 'Producer',
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'large',
    field: 'end_processor',
    filterable: true,
    headerName: 'End Processor',
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'large',
    field: 'loading_site',
    filterable: true,
    headerName: 'Loading site',
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'large',
    field: 'destination',
    filterable: true,
    headerName: 'Destination',
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'small',
    field: 'inspection_id',
    filterable: true,
    headerName: 'Has inspection',
    sortable: false,
    type: 'singleSelect',
    valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
    valueOptions: [
      {
        label: 'Yes',
        value: true,
      },
      {
        label: 'No',
        value: false,
      },
    ],
  },
  {
    columnSize: 'large',
    field: 'estimated_collection_time',
    filterable: false,
    headerName: 'Collection time',
    renderCell: (params) => {
      return params.value ? <DateField value={params.value} format="LLL" /> : 'N/A';
    },
    sortable: false,
  },
];
